import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { AsyncComponentErrorHandler } from 'crm-events-components/internal/helpers/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "sequence-edit-modal" */'sequences-crm-events-lib/components/modals/SequenceEnrollmentEditModal'),
  LoadingComponent: () => null,
  ErrorComponent: AsyncComponentErrorHandler('sequence-edit-modal')
});